(function($){
  $.fn.jTruncate = function(options) {

    var defaults = {
      length: 300,
      minTrail: 20,
      moreText: "more",
      lessText: "less",
      ellipsisText: "...",
      moreAni: " ",
      lessAni: " "
    };

    var options = $.extend(defaults, options);

    return this.each(function() {
      obj = $(this);
      var body = obj.html();

      if(body.length > options.length + options.minTrail) {
        var splitLocation = body.indexOf(' ', options.length);
        if(splitLocation != -1) {
          // truncate tip
          var splitLocation = body.indexOf(' ', options.length);
          var str1 = body.substring(0, splitLocation);
          var str2 = body.substring(splitLocation, body.length - 1);
          obj.html(str1 + '<span class="truncate_ellipsis">' + options.ellipsisText + 
                   '</span>' + '<span class="truncate_more">' + str2 + '</span>');
          obj.find('.truncate_more').css("display", "none");

          // insert more link
          obj.append(
            '<span class="clearboth">' +
            '<a href="#" class="truncate_more_link">' + options.moreText + '</a>' +
            '</span>'
          );

          // set onclick event for more/less link
          var moreLink = $('.truncate_more_link', obj);
          var moreContent = $('.truncate_more', obj);
          var ellipsis = $('.truncate_ellipsis', obj);
          moreLink.click(function() {
            if(moreLink.text() == options.moreText) {
              moreContent.show(options.moreAni);
              moreLink.text(options.lessText);
              ellipsis.css("display", "none");
            } else {
              moreContent.hide(options.lessAni);
              moreLink.text(options.moreText);
              ellipsis.css("display", "inline");
            }
            return false;
          });
        }
        obj.css('visibility', 'visible');
      } // end if

    });
  };
})(jQuery);  


$(document).ready(function() { 

  $('.expand').jTruncate({ 

    length: 80, /* The number of characters to display before truncating. */ 

    minTrail: 50, /* The minimum number of "extra" characters required to truncate. This option allows you to prevent truncation of a section of text that is only a few characters longer than the specified length. */

    moreText: " read more", // The text to use for the "more" link. 

    lessText: " read less", // The text to use for the "less" link. 

    ellipsisText: "... ", // The text to append to the truncated portion. 

  }); 

});

$(document).ready(function() { 

  $('.expand-detail').jTruncate({ 

    length: 180, /* The number of characters to display before truncating. */ 

    minTrail: 20, /* The minimum number of "extra" characters required to truncate. This option allows you to prevent truncation of a section of text that is only a few characters longer than the specified length. */

    moreText: " read more", // The text to use for the "more" link. 

    lessText: " read less", // The text to use for the "less" link. 

    ellipsisText: "...", // The text to append to the truncated portion. 

  }); 

});

$(document).ready(function() { 

  $('.product--expand').jTruncate({ 

    length: 220, /* The number of characters to display before truncating. */ 

    minTrail: 20, /* The minimum number of "extra" characters required to truncate. This option allows you to prevent truncation of a section of text that is only a few characters longer than the specified length. */

    moreText: " read more", // The text to use for the "more" link. 

    lessText: " read less", // The text to use for the "less" link. 

    ellipsisText: "...", // The text to append to the truncated portion. 

  }); 

});

$(document).ready(function() { 

  $('.expand-colour').jTruncate({ 

    length: 180, /* The number of characters to display before truncating. */ 

    minTrail: 20, /* The minimum number of "extra" characters required to truncate. This option allows you to prevent truncation of a section of text that is only a few characters longer than the specified length. */

    moreText: " read more", // The text to use for the "more" link. 

    lessText: " read less", // The text to use for the "less" link. 

    ellipsisText: "...", // The text to append to the truncated portion. 

  }); 

});

$(document).ready(function() { 

  $('.expand-user').jTruncate({ 

    length: 180, /* The number of characters to display before truncating. */ 

    minTrail: 20, /* The minimum number of "extra" characters required to truncate. This option allows you to prevent truncation of a section of text that is only a few characters longer than the specified length. */

    moreText: " read more", // The text to use for the "more" link. 

    lessText: " read less", // The text to use for the "less" link. 

    ellipsisText: "...", // The text to append to the truncated portion. 

  }); 

});

// ]]>